




















import { Component, Vue } from 'vue-property-decorator';
import { config } from '@/config';
import { PaymentIntent } from '@stripe/stripe-js';

@Component
export default class VerifyCreditCardPaymentPage extends Vue {
  private paymentIntentClientSecret: string = '';
  private paymentMethodId: string = '';

  public isLoading: boolean = false;

  public async created() {
    document.title = `${this.$t(this.$route.meta.title)} | Comply`;
    this.isLoading = true;
    try {
      await this.fetchFailedPaymentIntent();
      if (this.paymentIntentClientSecret && this.paymentMethodId) {
        await this.startVerification({
          paymentIntentClientSecret: this.paymentIntentClientSecret,
          paymentMethodId: this.paymentMethodId,
        });
      }
    } catch (error) {
      console.log(error);
    }
    this.isLoading = false;
  }

  public async fetchFailedPaymentIntent() {
    try {
      const paymentIntent: PaymentIntent = await this.$api.getLatestPaymentIntent();
      if (paymentIntent.client_secret) {
        this.paymentIntentClientSecret = paymentIntent.client_secret;
      }
      if (paymentIntent.payment_method) {
        this.paymentMethodId = paymentIntent.payment_method;
      }
    } catch (error) {
      console.log(error);
    }
  }

  public startVerification({
    paymentIntentClientSecret,
    paymentMethodId,
  }: {
    paymentIntentClientSecret: string;
    paymentMethodId: string;
  }) {
    this.$stripe
      .confirmCardPayment(paymentIntentClientSecret, {
        payment_method: paymentMethodId,
      })
      .then(function(result) {
        if (result.error) {
          // Show error to your customer
          console.log(result.error.message);
        } else {
          if (
            result.paymentIntent &&
            result.paymentIntent.status === 'succeeded'
          ) {
            // The payment is complete!
            window.location.replace(config.complyAppURL);
          }
        }
      });
  }
}
